import { damageCaseStatusOptions } from "../../baseInfo/damageCase/interfaces";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { AndFilter, ComparisonFilter, enmConditionalOperators } from "../../components/infrastructure/filtering";
import { enmVoucherStatus, enmVoucherTypes, IDamageCaseVoucherItem, IDamageCaseVoucherItemProps, IDamageCaseVoucherItemStates } from "../interfaces";

export class DamageCaseVoucherReceiptDraft extends EntityManager<IDamageCaseVoucherItem, IDamageCaseVoucherItemProps, IDamageCaseVoucherItemStates>{
    static initMetadata = (): IMetadata => {
        return {
            title: "پرونده های منتظر دریافت",
            name: "DamageCaseVoucherReceiptDraft",
            Properties: [
                {
                    title: "شماره پرونده",
                    dataIndex: "DamageCase.Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پیگیری",
                    dataIndex: "DamageCase.TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "DamageCase.Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: damageCaseStatusOptions },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "سریال بیمه نامه",
                    dataIndex: "DamageCase.PolicyEquipmentModel.Policy.SerialNo",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "PolicyholderNationalCode",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "PolicyholderFullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200
                },
                {
                    title: "مبلغ قابل دریافت",
                    dataIndex: "Amount",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    filterable: false,
                    sortable: false,
                    width: 180,
                    formatter: (value) => {
                        return `ريال ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }

            ]
        };
    }
    onInitializing() {
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.originalFilter = () => {
            return new AndFilter([
                new ComparisonFilter("Voucher.Status", enmConditionalOperators.Equal, enmVoucherStatus.Issued),
                new ComparisonFilter("Voucher.Type", enmConditionalOperators.Equal, enmVoucherTypes.Receipt)
            ]);
        };
    }
}